import { Column } from "plos/src/components/Table";
import SortDescIcon from "plos/src/img/icons/sort-down.svg?react";
import SortAscIcon from "plos/src/img/icons/sort-up.svg?react";
import SortIcon from "plos/src/img/icons/sort.svg?react";
import { SortDirection } from "react-aria-components";
import styles from "../priceChanges.module.css";

const sortIcons: Record<SortDirection, typeof SortIcon> = {
  ascending: SortAscIcon,
  descending: SortDescIcon,
};

interface SortableColumnProps {
  id: string;
  label: string;
  className: string;
  isRowHeader?: boolean;
}

const SortableColumn = ({
  id,
  label,
  className,
  isRowHeader,
}: SortableColumnProps) => (
  <Column
    id={id}
    isRowHeader={isRowHeader}
    allowsSorting
    className={({ sortDirection }) =>
      [
        className,
        styles.sortableColumn,
        sortDirection && styles.sortedHeaderCell,
      ]
        .filter(Boolean)
        .join(" ")
    }
  >
    {({ sortDirection }) => {
      const Icon = sortDirection ? sortIcons[sortDirection] : SortIcon;
      return (
        <span className={styles.sortableHeader}>
          {label}
          <Icon className={styles.sortIcon} aria-hidden />
        </span>
      );
    }}
  </Column>
);

export default SortableColumn;
